import { HomeDisplayCategory } from 'src/admin-entity/interface/home-display/home-display-category.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';

export interface HomeDisplayCategoryInitType {
    name: string;
    parentName: string;
    title: string;
    displayStatus: any;
    item: any;
    selectedSearchedHomeDisplay: HomeDisplayCategory[];
    searchResult: Page<HomeDisplayCategory>;
    searchResultPage: {
        count: number;
    };
    page: number;
    take: number;
}

export const initialState: HomeDisplayCategoryInitType = {
    name: '',
    parentName: '',
    title: '',
    displayStatus: 'true',
    item: '',
    selectedSearchedHomeDisplay: [],
    searchResult: {
        list: [],
        page: {
            count: 0,
            nextPage: 0,
        },
    },
    searchResultPage: {
        count: 0,
    },
    page: 0,
    take: 0,
};
